import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import classNames from "classnames";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./CustomerCell.module.scss";

export const CustomerCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, any>) => {
        const invoice = row.original;
        const { getCopyProps: getCopyPropsCounterparty } = useIdCopy({
            label: "Counterparty",
        });

        return (
            <ViewTableCell>
                <div className={styles.customerContent}>
                    {invoice.counterparty ? (
                        <>
                            <span
                                className={styles.customerName}
                                {...getCopyPropsCounterparty(
                                    invoice.counterparty?.id,
                                )}
                            >
                                {invoice.counterparty?.name}
                            </span>
                            {invoice.counterparty?.email && (
                                <CopyOnClick
                                    className={classNames(
                                        styles.customerEmail,
                                        styles.leftAligned,
                                    )}
                                    value={invoice.counterparty?.email}
                                    tooltipText="Copy email"
                                    stopPropagation
                                >
                                    {invoice.counterparty?.email}
                                </CopyOnClick>
                            )}
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            </ViewTableCell>
        );
    },
);
